import { HOUR_TO_MILLISECONDS_FACTOR } from 'technical/time-utils/constants';

import { formatGraphDataWithDuration } from './format-graph-data-with-duration';

export const getGraphMaxValue = (
  data: ReturnType<typeof formatGraphDataWithDuration>,
  showTotalDurations: boolean | undefined,
) => {
  const maxInMilliseconds = data.reduce(
    (
      acc,
      {
        realBuildDuration,
        realExcavationDuration,
        totalBuildDuration,
        totalExcavationDuration,
      },
    ) => {
      return Math.max(
        acc,
        realBuildDuration,
        realExcavationDuration,
        ...(showTotalDurations
          ? [totalBuildDuration, totalExcavationDuration]
          : []),
      );
    },
    0,
  );

  return maxInMilliseconds / HOUR_TO_MILLISECONDS_FACTOR;
};
